import { render, staticRenderFns } from "./ArticleHistoryDialog.vue?vue&type=template&id=6313e97f"
import script from "./ArticleHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleHistoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports